import { Card, Descriptions, Grid, Layout } from "antd";
import Title from "antd/es/typography/Title";
import React from "react";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../constants";
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const TITLE = "Transaction Summary";
export interface TransactionsLiteProps {
  data: TransactionData;
}

export interface TransactionData {
  totalReceived: number;
  totalSent: number;
  transactionsData: {
    createdAt?: Date;
    reason?: string | null;
  }[];
}

export const TransactionsLite: React.FC<TransactionsLiteProps> = (props) => {
  const screen = Grid.useBreakpoint();
  const isMobile = screen.xs;

  const getTransactions = () => {
    if (props.data.transactionsData.length === 0) {
      return <p className="px-5">No transactions have been made for this application.</p>;
    } else {
      return props.data.transactionsData.map((transaction) =>
        transaction ? (
          <React.Fragment key={transaction?.reason}>
            <Card style={{width: "100%"}} bordered={true}>
              <Descriptions title={undefined} layout="vertical" size="small" column={isMobile ? 2 : 3} className={isMobile ? "" : "w-[600px]"}>
                <Descriptions.Item label="Date">{dayjs(transaction.createdAt).format(DATE_FORMAT).toUpperCase()}</Descriptions.Item>
                <Descriptions.Item label="Description">{transaction.reason}</Descriptions.Item>
                  <Descriptions.Item label="Activity">
                    <button style={{ backgroundColor: "lightgray", border: "1px solid black", fontSize: "small", borderRadius: "0", marginTop: "6px" }}>
                    {`Sent ${dayjs(transaction.createdAt).format(DATE_FORMAT).toUpperCase()}`}
                    </button>
                  </Descriptions.Item>
              </Descriptions>
            </Card>
          </React.Fragment>
        ) : null
      )
    }
  }

  return (
    <Layout style={{ width: isMobile ? "100%" : "700px", paddingRight: '10px', marginBottom: '70px'}}>
      <Title style={{ marginBottom: "10px" }} level={5}>
        {TITLE}
      </Title>
      <br />
      <Descriptions title={undefined} layout="vertical" size="small" column={2} className="w-[300px]">
        <Descriptions.Item label="Total Received">
          US${props.data.totalReceived}
        </Descriptions.Item>
        <Descriptions.Item label="Total Sent">
          US${props.data.totalSent}
        </Descriptions.Item>
      </Descriptions>
      <h4 style={{ marginTop: "10px" }}>Transactions</h4>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {getTransactions()}
      </div>
    </Layout>
  );
};
